/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import { Request, Create } from '../EpicUtils';
import { GET_GA4_WEB_STREAMS, setGtmAndGaData } from '../../actions/Google';
import GoogleService from '../../../api/services/GoogleService';
import { getTokenString } from '../../../utils/Google';
import { GAProfilesRequestAction, GoogleState } from '../../../models/Google';

const request: Request<GoogleState, GAProfilesRequestAction> = {
  type: GET_GA4_WEB_STREAMS,
  getData: async ({ gaPropertyId }, state) => {
    const token = getTokenString(state.google);
    const ga4WebStreams = { ...state.google.ga4WebStreams };

    const streams = await GoogleService.getGAV4WebStreams(
      token,
      gaPropertyId
    );
    if (streams.dataStreams) {
      ga4WebStreams[gaPropertyId] = streams.dataStreams;
    }

    return {
      ga4WebStreams
    };
  },
  processData: (res) => [
    setGtmAndGaData(res)
  ],
};

export const EpicGetGA4WebStreams: Epic<any, any> = Create(request);